import { render, staticRenderFns } from "./huozhu.vue?vue&type=template&id=776bd61c&"
import script from "./huozhu.vue?vue&type=script&lang=js&"
export * from "./huozhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports